import React from 'react';

import i18next from 'i18next';
import isEmpty from 'lodash/isEmpty';

import CostWorkFields from '../../components/CostWorkFields';
import OpexFields from '../../components/OpexFields';
import { createPartnerConfig } from '../base/PartnerConfigFactory';

import Parameters from './Parameters';
import validate from './validate';

export const name = 'KAM';

const config = createPartnerConfig({
    ParametersComponent: Parameters,
    buildPayloadConfig: {
        extendPayload: (basePayload, values) => {
            const {
                api_key,
                file_rate,
                financial_work_cost_month,
                opex,
                opex_active,
                opex_cost_ranges_kw,
                opex_costing_type,
                opex_percentage_increase,
                opex_periodicity,
                percentage_work_funding,
                work_cost_active,
                work_cost_ranges,
            } = values;

            const extended = {
                ...basePayload,
                financial_work_cost_month,
                opex,
                opex_active,
                opex_cost_ranges_kw: JSON.stringify(opex_cost_ranges_kw),
                opex_costing_type,
                opex_percentage: opex_percentage_increase,
                opex_periodicity,
                percentage_work_funding,
                work_cost_active,
                work_cost_ranges: JSON.stringify(work_cost_ranges),
            };

            // Agregar file_rate si existe
            if (Array.isArray(file_rate) && file_rate.length > 0) {
                extended.file_rate = file_rate[0];
            }

            // Agregar API key si no está vacío
            if (!isEmpty(api_key)) {
                extended.api_key = api_key;
            }

            return extended;
        },
    },
    buildPrepareValuesConfig: {
        extendPrepareValues: (baseValues, values) => ({
            ...baseValues,
            api_key: values.api_key || '',
            dealer_fee: values.parameters[0]?.dealer_fee || 0,
            file_rate: values.parameters[0]?.file_rate || null,
            financial_work_cost_month: values.financial_work_cost_month || 0,
            opex: values.opex || 0,
            opex_active: values.opex_active || false,
            opex_cost_ranges_kw: values.opex_cost_ranges_kw || [],
            opex_costing_type: values.opex_costing_type || 'by_fixed_amount',
            opex_percentage_increase: values.opex_percentage || 0,
            opex_periodicity: values.opex_periodicity || 1,
            percentage_work_funding: values.percentage_work_funding || 0,
            work_cost_active: values.work_cost_active || false,
            work_cost_ranges: values.work_cost_ranges || [],
        }),
    },
    customAlgorithms: [
        { label: 'PPA Algorithm', value: 'ppa_api_key' },
        { label: 'BESS API', value: 'bess_api_key' },
        { label: 'PTO API', value: 'pto_api_key' },
        { label: 'PV BESS API Key', value: 'pv_bess_api_key' },
        { label: 'Installment sale', value: 'ppa_installment' },
    ],
    name,
    tabsConfig: {
        additionalTabs: ({
            control,
            disabled,
            getValues,
            setValue,
            typeAlgorithm,
        }) => [
            {
                component: (
                    <OpexFields
                        control={control}
                        currencyIso="USD"
                        currencySymbol="$"
                        disabled={disabled}
                        getValues={getValues}
                        setValue={setValue}
                    />
                ),
                id: 'tab-opex',
                label: 'OPEX',
                value: 'opex',
                visible: typeAlgorithm === 'ppa_installment',
            },
            {
                component: (
                    <CostWorkFields
                        control={control}
                        disabled={disabled}
                        getValues={getValues}
                        setValue={setValue}
                    />
                ),
                id: 'tab-cost-of-work',
                label: i18next.t('Cost of work'),
                value: 'cost-of-work',
                visible: typeAlgorithm === 'ppa_installment',
            },
        ],
    },
    validationConfig: { schema: validate },
});

const originalGetInitialValues = config.getInitialValues;
config.getInitialValues = () => ({
    ...originalGetInitialValues(),
    api_key: '',
    financial_work_cost_month: 0,
    opex: 0,
    opex_active: false,
    opex_cost_ranges_kw: [{ amount: 0, max: 10, min: 0 }],
    opex_costing_type: 'by_fixed_amount',
    opex_percentage_increase: 0,
    opex_periodicity: 1,
    percentage_work_funding: 0,
    work_cost_active: false,
    work_cost_ranges: [{ max: 10, min: 0, month: 1 }],
});

export default { ...config, name };
